module.exports = __webpack_public_path__ + "static/personpc-f253a0baa04dc9cefb5e9d8052161852.png";